const COMMON_CONFIGS = {
  recaptcha_key: process.env.REACT_APP_RECAPTCHA_SECRET_KEY,
  socket_url: process.env.REACT_APP_SOCKET_URL,
  env: process.env.NODE_ENV,
  base_url: process.env.REACT_APP_GATEWAY_URL,
  meeting_api_url: process.env.REACT_APP_MEETINGS_URL,
  viewer_url: process.env.REACT_APP_VIEWER_URL
};

const config = {
  production: {
    ...COMMON_CONFIGS
  },
  development: {
    ...COMMON_CONFIGS
  },
  test: {
    ...COMMON_CONFIGS
  }
};

export default config[process.env.NODE_ENV];
